import React from 'react';

export const BackgroundIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 4V3C17.5 2.45 17.05 2 16.5 2H4.5C3.95 2 3.5 2.45 3.5 3V7C3.5 7.55 3.95 8 4.5 8H16.5C17.05 8 17.5 7.55 17.5 7V6H18.5V10H9.5C8.95 10 8.5 10.45 8.5 11V21C8.5 21.55 8.95 22 9.5 22H11.5C12.05 22 12.5 21.55 12.5 21V12H19.5C20.05 12 20.5 11.55 20.5 11V5C20.5 4.45 20.05 4 19.5 4H17.5Z"
      fill="#0A0A0B"
    />
  </svg>
);

export default BackgroundIcon;
